<app-survey-frame-list *ngFor="let address of building.addresses; let i = index">
  <app-survey-frame-list-template [index]="index" [noClick]="true">
    <div class="templateHeader" header>
      <div class="header-part">
        <ng-container *ngIf="!inPortrait">
          <div class="vertical-flex">
            <span class="bold">
              <span i18n="@@survey.inside.addressinfo.title.building"
                >Building</span
              >
              <span> {{ buildingIndex }}</span>
            </span>
            <span>{{ buildingKey ?? "-" }}</span>
          </div>
          <div class="vertical-flex">
            <span class="bold">|</span>
            <span>|</span>
          </div>
          <div class="vertical-flex">
            <span class="bold">
              <span i18n="@@general.address">Address</span>
              {{ i + 1 }}
            </span>
            <span>{{ address?.lomKey ?? "-" }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="inPortrait">
          <div class="vertical-flex portrait">
            <span
              ><span class="bold">B{{ buildingIndex }}</span> -
              <span class="small">{{ buildingKey ?? "" }}</span></span
            >
            <span
              ><span class="bold">A{{ i + 1 }}</span> -
              <span class="small">{{ address.lomKey ?? "" }}</span></span
            >
          </div>
        </ng-container>
      </div>
      <div class="header-part">
        <span class="address"> {{ address.getFullAddress() }}</span>
      </div>
      <div class="header-part grow"></div>
      <div class="header-part">
        <div class="circle" *ngIf="address.isMainAddress">
          <mat-icon class="material-icons-outlined"> home </mat-icon>
        </div>
        <div (click)="onAddressChecked(address)" class="circle grey-color clickable" *ngIf="canChangeMainAddress(address)">
          <mat-icon class="material-icons-outlined"> home </mat-icon>
        </div>
      </div>
    </div>
  </app-survey-frame-list-template>
</app-survey-frame-list>
